/* index.js */

"use strict";

// const { labelByTypeData } = require("../CustomFieldsConstants");

module.exports = {
    defaultValueFormatter,
    deleteButtonFormatter,
    ipTypeValueFormatter,
    exclusionValueFormatter,
    credTypeFormatter,
    exclusionTypeFormatter,
};

function deleteButtonFormatter(row, cell, value, columnDef, dataContext) {
    let action = "delete";
    let actionEdit = "edit";
    if (columnDef.field === "actionsCredentials") {
        action = "delete-cred";
        actionEdit = "edit-cred";
    } else if (columnDef.field === "actionsExclusions") {
        action = "delete-exclusion";
        actionEdit = "edit-exclusion";
    }

    const buttonEdit = document.createElement("base-icon-gl");
    buttonEdit.dataset.icon = "common.single_edit";
    buttonEdit.setDarkTheme(false);

    buttonEdit.setAttribute("aria-label", `edit ${dataContext.name}`);
    buttonEdit.setAttribute("role", "button");
    buttonEdit.setAttribute("plan-id", columnDef.planId);

    buttonEdit.dataset.uuid = dataContext.id;
    buttonEdit.dataset.action = actionEdit;

    const button = document.createElement("base-icon-gl");
    button.dataset.icon = "common.trash_bin";
    button.setDarkTheme(false);

    button.setAttribute("aria-label", `delete ${dataContext.name}`);
    button.setAttribute("role", "button");
    button.setAttribute("plan-id", columnDef.planId);

    button.dataset.uuid = dataContext.id;
    button.dataset.action = action;

    const buttonContainer = document.createElement("span");
    buttonContainer.classList.add("button-action-container");

    buttonContainer.appendChild(buttonEdit);
    buttonContainer.appendChild(button);

    if (columnDef.field === "actionsExclusions" && dataContext.orgLevel === true) {
        buttonContainer.classList.add("no-edit");
    }

    return buttonContainer.outerHTML;
}

function defaultValueFormatter(row, cell, value) {
    const span = document.createElement("span");
    span.classList.add("default-value");
    span.setAttribute("title", value);
    span.innerText = value;

    return span.outerHTML;
}

function ipTypeValueFormatter(row, cell, value) {
    const TYPES = {
        ipRange: "IP Range",
        ipBlock: "IP Block",
    };

    const span = document.createElement("span");
    span.classList.add("type-value");
    span.setAttribute("title", TYPES[value]);
    span.innerText = TYPES[value];

    return span.outerHTML;
}

function credTypeFormatter(row, cell, value) {
    const TYPES = {
        login: "Login",
        enableMode: "Enable Mode",
    };

    const span = document.createElement("span");
    span.classList.add("type-value");
    span.setAttribute("title", TYPES[value]);
    span.innerText = TYPES[value];

    return span.outerHTML;
}

function exclusionTypeFormatter(row, cell, value, columnDef) {
    const TYPES = columnDef.context.types;

    const span = document.createElement("span");
    span.classList.add("type-value");
    span.setAttribute("title", TYPES[value]);
    span.innerText = TYPES[value];

    return span.outerHTML;
}
function exclusionValueFormatter(row, cell, value, columnDef, dataContext) {
    let val;
    switch (dataContext.type) {
        case "deviceType":
            val = dataContext.typeBaseMap[value] || value;
            break;
        case "hostName":
            val = value;
            break;
        case "ipAddress":
            val = value;
            break;
        case "ipBlock":
            val = value;
            break;
        case "ipRange":
            val = `${value.start} - ${value.end}`;
            break;
        case "serialNumber":
            val = value;
            break;
        default:
            val = value;
            break;
    }
    return val;
}
